// Returns array of available time slots for a given Date.
// Closed Tuesdays. Lunch every open day; Dinner only Thu/Fri/Sat.
export function horasDisponibles(dateStr) {
    if (!dateStr) return [];
    const d = new Date(dateStr + "T00:00:00");
    const day = d.getDay(); // 0 Sun .. 6 Sat
    if (day === 2) return []; // martes closed

    const comida = [
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
    ];
    const cena = ["20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00"];

    // Thu(4), Fri(5), Sat(6) => add dinner
    if (day === 4 || day === 5 || day === 6) return [...comida, ...cena];
    return comida;
}

export function esMartes(dateStr) {
    if (!dateStr) return false;
    return new Date(dateStr + "T00:00:00").getDay() === 2;
}

export const HORARIO_TEXTO = [
    { dia: "Lunes", horas: "11:00 – 16:30", cerrado: false },
    { dia: "Martes", horas: "Cerrado", cerrado: true },
    { dia: "Miércoles", horas: "11:00 – 16:30", cerrado: false },
    { dia: "Jueves", horas: "11:00 – 16:30 · 20:00 – 23:00", cerrado: false },
    { dia: "Viernes", horas: "11:00 – 16:30 · 20:00 – 23:00", cerrado: false },
    { dia: "Sábado", horas: "11:00 – 16:30 · 20:00 – 23:00", cerrado: false },
    { dia: "Domingo", horas: "11:00 – 16:30", cerrado: false },
];
